import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { build } from 'pdfjs-dist';
import { buildApiUrl } from '../../../services/apiConfig';

const TickerCarousel = () => {
  const [tickers, setTickers] = useState([
    { symbol: 'S&P 500', price: 6939.03, change: -0.43 },
    { symbol: 'DOW', price: 48892.47, change: -0.36 },
    { symbol: 'NASDAQ', price: 23461.82, change: -0.94 },
    { symbol: 'AAPL', price: 259.48, change: 0.46 },
    { symbol: 'MSFT', price: 430.29, change: -0.74 },
    { symbol: 'AMZN', price: 239.30, change: -1.01 },
    { symbol: 'GOOGL', price: 338.00, change: -0.07 },
    { symbol: 'TSLA', price: 430.41, change: 3.32 }
  ]);
  const [loading, setLoading] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);

  useEffect(() => {
    const fetchTickers = async () => {
      try {
        setLoading(true);
        const response = await axios.get(buildApiUrl('NEWS', '/tickers'));
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          setTickers(response.data);
          setLastUpdate(new Date());
        }
      } catch (error) {
        console.error('Error fetching ticker data:', error);
        // Keep using the default/last known data
      } finally {
        setLoading(false);
      }
    };

    // Initial fetch
    fetchTickers();
    
    // Refresh ticker data every 2 minutes during market hours
    const intervalId = setInterval(fetchTickers, 2 * 60 * 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="bg-gray-900 py-1.5 overflow-hidden border-b border-gray-800 relative">
      <div className="flex animate-marquee whitespace-nowrap">
        {tickers.concat(tickers).map((ticker, index) => (
          <div key={index} className="flex items-center mx-6">
            <span className="font-semibold text-sm text-white">{ticker.symbol}</span>
            <span className="ml-2 text-sm text-gray-300 font-medium">${ticker.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            <span className={`ml-2 text-xs font-medium ${ticker.change >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
              {ticker.change >= 0 ? '▲' : '▼'} {Math.abs(ticker.change).toFixed(2)}%
            </span>
          </div>
        ))}
      </div>
      {lastUpdate && (
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">
          Updated: {lastUpdate.toLocaleTimeString()}
        </div>
      )}
    </div>
  );
};

export default TickerCarousel;